import { TNMIAddress } from './types';
import { useEffect, useRef, useState } from 'react';

interface UseAddressesChanged {
  hasAddressesChanged: () => boolean;
}

export function useAddressesChanged(addresses: TNMIAddress[]): UseAddressesChanged {
  const [_addresses, setAddresses] = useState<TNMIAddress[] | null>([]);
  const ref = useRef<TNMIAddress[] | null>(null);

  useEffect(() => {
    ref.current = addresses;
  }, [addresses]);

  const createDiff = (addresses: TNMIAddress[] | null): string => {
    return JSON.stringify(addresses?.map((addr) => addr.nmi));
  };

  const hasAddressesChanged = (): boolean => {
    if (createDiff(ref.current) === createDiff(_addresses)) {
      return false;
    }

    setAddresses(ref.current);
    return true;
  };

  return {
    hasAddressesChanged,
  };
}
